import { useParams } from '@reach/router';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ClientInfo } from '../../components/clients/clientInfo';
import { Layout } from '../../components/ui/Layout';
import { setActiveCustomer } from '../../redux/actions/clients';

const ClientDetailScreen = () => {
  const dispatch = useDispatch();
  const params = useParams();

  useEffect(() => {
    dispatch(setActiveCustomer(params.PkClientes));
  }, [dispatch, params.PkClientes]);

  return (
    <Layout>
      <div style={{ marginTop: '2rem' }} />
      <ClientInfo />
    </Layout>
  );
};

export default ClientDetailScreen;
